import { render, staticRenderFns } from "./TuberCulinSkin.vue?vue&type=template&id=00ce353e&scoped=true"
import script from "./TuberCulinSkin.vue?vue&type=script&lang=js"
export * from "./TuberCulinSkin.vue?vue&type=script&lang=js"
import style0 from "./TuberCulinSkin.vue?vue&type=style&index=0&id=00ce353e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ce353e",
  null
  
)

export default component.exports